import { EmailVerificationPage } from "@/features/auth";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/email-verification")({
  component: EmailVerificationPage,
});
